import { relationshipTierIndex, relationshipTierLabel, nextRpMilestone } from './relationshipLevels';
import { buildLive2dModelUrlFromParts } from '../utils/live2dUrls';

const PUBLIC = typeof process !== 'undefined' ? process.env.PUBLIC_URL || '' : '';

function buildLive2dModelUrl(char) {
  return buildLive2dModelUrlFromParts(PUBLIC, char?.live2dPack, char?.live2dModelPath);
}

function preferencesLine(char) {
  const parts = [];
  if (char?.preferenceDominant) parts.push('Dominant');
  if (char?.preferenceSubmissive) parts.push('Submissive');
  return parts.length ? parts.join(' · ') : '—';
}

/** Карточки для GameCharacterWindow из каталога персонажей и userState.characters */
export function buildLobbyCharacterProfiles(catalog, sessionChars, gameConfig) {
  return (catalog || []).map((char) => {
    const id = String(char._id);
    const row = (sessionChars || []).find((x) => String(x.characterId) === id);
    const rp = Number(row?.relationship) || 0;
    const tier = relationshipTierIndex(rp, gameConfig);
    const milestone = nextRpMilestone(rp, tier, gameConfig);
    const body = (char.description || char.neutral || '').trim();
    const live2dModelUrl = buildLive2dModelUrl(char);
    const mi = Number(char?.live2dIdleMotionIndex);
    const live2dIdleMotionIndex = Number.isFinite(mi) && mi >= 0 ? Math.floor(mi) : 0;
    return {
      _id: id,
      name: char.name,
      description: (body || '—').slice(0, 400),
      relationshipLabel: relationshipTierLabel(tier),
      rpCurrent: rp,
      rpNext: Math.max(rp + 1, milestone),
      preferences: preferencesLine(char),
      sessionNumber: Number(row?.sessionNumber) || 0,
      avatarGridUrl: (char.avatarGridUrl || '').trim(),
      avatarChatUrl: (char.avatarChatUrl || '').trim(),
      live2dModelUrl,
      live2dIdleMotionIndex
    };
  });
}
